/*
 * 做题主页面--视频讲解和在线资料最小化时，在最左下角的左边距计算函数
 * @param selfClassName 自身弹层的class名
 * @param otherClassName 对方弹层的class名
 *
 */
export function calcMinDialogLeft(selfClassName, otherClassName) {
    setTimeout(() => {
        const self = document.getElementsByClassName(selfClassName)[0].getElementsByClassName("el-dialog")[0]

        const otherParent = document.getElementsByClassName(otherClassName)[0]
        if (!otherParent) {
            self.style.setProperty('margin-left', `0`, 'important');
            return
        }
        const otherEl = otherParent.getElementsByClassName("el-dialog")[0]
        if (!otherEl || !self) {
            self.style.setProperty('margin-left', `0`, 'important');
            return
        }
        const otherExist = otherParent && otherParent.classList.contains('min-size');
        if (!otherExist) { // 其他没有最小化
            self.style.setProperty('margin-left', `0`, 'important');
            return
        }
        self.style.setProperty('margin-left', `${otherEl.getBoundingClientRect().width + 1}px`, 'important');
    }, 100)
}
